import React from "react";
import useRazorpay from "react-razorpay";
import { useNavigate } from "react-router-dom";
import { SweetAlert } from "../../helpers/helper";
import { post } from "../../components/api";

const TokenPayment = () => {
  const [Razorpay] = useRazorpay();
  let navigate = useNavigate();

  // Razor pay payment
  const handlePayment = async () => {
    try {
      const data = {
        loadId: "67921f6c46f97c44262f06db",
        amount: 500,
      };
      // Create order on your backend and retrieve the order details
      const order = await createOrder(data);
      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY, // Your Razorpay Key ID
        amount: order.amount, // Order amount in paise (e.g., 50000 for ₹500.00)
        currency: order.currency,
        name: "FleetStakes Pvt.LTD",
        description: "Test Transaction",
        image:
          "http://localhost:3000/static/media/logo.91ed4b160f822935a22b.png",
        order_id: order.orderId, // Pass the order ID obtained from your backend
        prefill: {
          name: "Sedhal Soni",
          email: "testing.cloudstakes12@gmail.com",
          contact: "7984312620",
        },
        notes: {
          address: "Razorpay Corporate Office",
        },
        theme: {
          color: "#3399cc",
        },
        handler: function (response) {
          console.log("response", response);
          // Handle successful payment
          console.log(response.razorpay_payment_id);
          console.log(response.razorpay_order_id);
          console.log(response.razorpay_signature);
          setTimeout(() => {
            navigate("/orders");
          }, 2000);
        },
        modal: {
          ondismiss: function () {
            // Handle the case when the user closes the payment modal without completing the payment
            console.log("Payment modal has been dismissed");
          },
        },
      };
      const rzp1 = new Razorpay(options);
      rzp1.open();
    } catch (error) {
      console.error("Error processing payment:", error);
    }
  };

  async function createOrder(params) {
    const response = await post("/admin/ltms/create-order", params);
    if (response.status == 200) {
      return response.data;
    } else {
      SweetAlert(response.message, true);
    }
  }

  return (
    <div className="text-center mt-5">
      <button className="btn btn-primary btn-lg" onClick={handlePayment}>
        Pay ₹500
      </button>
    </div>
  );
};
export default TokenPayment;
